// extracted by mini-css-extract-plugin
export var Content = "index-module--Content--91715";
export var FeaturedPost = "index-module--FeaturedPost--368ad";
export var Four04 = "index-module--Four04--6799a";
export var Header = "index-module--Header--9b099";
export var HeaderInner = "index-module--HeaderInner--187de";
export var MainPages = "index-module--MainPages--4f32a";
export var MainPagesLink = "index-module--MainPagesLink--19e3c";
export var MainPagesLinks = "index-module--MainPagesLinks--83e2c";
export var PostChildren = "index-module--PostChildren--1d5d7";
export var PostHover = "index-module--PostHover--fa30c";
export var PostOrphans = "index-module--PostOrphans--3c696";
export var Posts = "index-module--Posts--bd440";
export var showDesktop = "index-module--showDesktop--fd142";
export var showMobile = "index-module--showMobile--4b5ae";